import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {DecisionGridChangeLogService} from '../../../Services/decision-grid-change-log.service';
import {DecisionGridChangeLogDetailModel} from '../../../Models/decision-grid-change-log-detail-model';
import {DecisionGridChangeLogSummaryModel} from '../../../Models/decision-grid-change-log-summary-model';
import { ClientService } from 'src/app/clients-module/services/client.service';


@Component({
  selector: 'app-change-log-summary-listing',
  templateUrl: './change-log-summary-listing.component.html',
  styleUrls: ['./change-log-summary-listing.component.less'],
  encapsulation: ViewEncapsulation.None,
})
export class ChangeLogSummaryListingComponent implements OnInit {

  constructor(
    private readonly clientService: ClientService,
    public readonly decisionGridChangeLogService: DecisionGridChangeLogService
  ) {
  }

  public ngOnInit(): void {

    this.decisionGridChangeLogService.getDecisionGridChangeLogSummary(this.clientService.currentClient.id).subscribe();

  }

}
